/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import FormGroup from "@material-ui/core/FormGroup";
import styled from "styled-components";

import Checkbox from "./checkbox";
import {
  StyledHelperText,
  StyledLabel,
  StyledRequired,
} from "../superAdmin/catalog/lib/styles";

type CheckboxOptions = {
  id: string;
  key: string;
  name: string;
};

type CheckboxGroupInputFieldPropTypes = {
  disabled?: boolean;
  handleChange: (selectedIds) => void;
  helperText?: string;
  id: string;
  isRequired?: boolean;
  label: string;
  options: CheckboxOptions[];
  selectedOptions: CheckboxOptions[];
};

const StyledCheckboxSpacer = styled.div`
  margin-bottom: 5px;
  margin-left: -5px;
`;

const CheckboxGroupInputField = ({
  disabled,
  handleChange,
  helperText,
  id,
  isRequired,
  label,
  options,
  selectedOptions,
}: CheckboxGroupInputFieldPropTypes): React.ReactElement => {
  const handleCheckboxChange = (checked, selectedId): void => {
    let newSelectedOptions = [...selectedOptions];
    const newOption = options.find((option) => {
      return option.id === selectedId;
    });
    if (checked) {
      newSelectedOptions.push(newOption);
    } else {
      newSelectedOptions = selectedOptions.filter(
        (option) => option.id !== newOption.id
      );
    }

    handleChange(newSelectedOptions);
  };

  return (
    <>
      <StyledLabel>
        {label}
        {isRequired && <StyledRequired>*</StyledRequired>}
      </StyledLabel>

      {helperText && <StyledHelperText>{helperText}</StyledHelperText>}

      <FormGroup data-testid={id}>
        {options.map((option) => {
          const checked = !!selectedOptions.find((selected) => {
            return selected.id === option.id;
          });
          return (
            <StyledCheckboxSpacer key={option.id}>
              <Checkbox
                checked={checked}
                data-checked={checked}
                data-testid={`${option.key}-checkbox`}
                disabled={disabled}
                handleChange={(event): void => {
                  return handleCheckboxChange(event.target.checked, option.id);
                }}
                id={`${option.key}-checkbox`}
                label={option.name}
              />
            </StyledCheckboxSpacer>
          );
        })}
      </FormGroup>
    </>
  );
};

CheckboxGroupInputField.defaultProps = {
  helperText: "",
  isRequired: false,
};

export default CheckboxGroupInputField;
